package it.unibo.tuprolog.parser.tree

/** Syntactic role selected for one operator occurrence. */
enum class OperatorRole {
    PREFIX,
    INFIX,
    POSTFIX,
}
